module.exports = __webpack_public_path__ + "img/logo.117d508d.svg";